import Vue from 'vue';

import { apiPath } from '@/api/constants';

export default Vue.resource(
  `${apiPath}/adbazaar/v2/campaigns{/itemId}/bids/bulk`,
  {},
  {},
);
